import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { PassphraseFormChanges } from '@shared/models/passphrase-form-changes.model';
import { ChoosePassphraseComponent } from '@shared/components/choose-passphrase/choose-passphrase.component';

import { FormGroup } from '@angular/forms';

@Component({
  selector: 'worm-choose-passphrase',
  templateUrl: './worm-choose-passphrase.component.html',
  styleUrls: ['./worm-choose-passphrase.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WormChoosePassphraseComponent implements OnInit {

  @Input() defaultPassphrase: string;
  @Input() get value(): string {
    return this.currentPassphrase;
  }
  @Input() get validate(): Function {
    return () => this.passphraseForm.valid;
  }

  @ViewChild(ChoosePassphraseComponent) formComponent: ChoosePassphraseComponent;

  private currentPassphrase: string;
  private passphraseForm: FormGroup;

  ngOnInit(): void {
    this.currentPassphrase = this.defaultPassphrase;
  }

  onPassphraseFormEvents(payload: PassphraseFormChanges) {
    const { form, summary } = payload;
    this.currentPassphrase = summary.type === 'default'
      ? this.defaultPassphrase
      : summary.passphrase;
    this.passphraseForm = form;
  }
}
